'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _SimpleButton = require('../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INFO_MESSAGE = 'Enter your phone number so that\nrestaurant can contact you regarding your order.';

var UserProfile = function (_React$Component) {
    _inherits(UserProfile, _React$Component);

    function UserProfile(props) {
        _classCallCheck(this, UserProfile);

        var _this = _possibleConstructorReturn(this, (UserProfile.__proto__ || Object.getPrototypeOf(UserProfile)).call(this, props));

        _this.populateUserDetails = function () {
            var currentUser = _parse2.default.User.current();
            var phoneNumber = currentUser.get("phoneNumber");
            var infoMessage = null;

            if (!phoneNumber) {
                infoMessage = INFO_MESSAGE;
            }
            _this.setState({
                name: currentUser.get('name'),
                email: currentUser.get('email'),
                phoneNumber: Utils.formatPhoneNumber(currentUser.get("phoneNumber")),
                infoMessage: infoMessage,
                readOnly: currentUser.get('email') ? true : false
            });
        };

        _this.keyDown = function (e) {
            _this.setState({ error: '' });
            if (e.keyCode === 13) {
                _this.submit();
            }
        };

        _this.changeName = function (e) {
            _this.setState({
                name: e.target.value
            });
        };

        _this.changeEmail = function (e) {
            _this.setState({
                email: e.target.value
            });
        };

        _this.handleInput = function (e) {
            // console.log(e);

            // console.log(e.target.value);
            // this is where we'll call the phoneNumberFormatter function
            var formattedPhoneNumber = Utils.convertStringToPhoneNumberFormat(e.target.value);

            _this.setState({
                phoneNumber: formattedPhoneNumber
            });
        };

        _this.validateUserDetails = function () {
            return !Utils.isEmpty(_this.state.name) && !Utils.isEmpty(_this.state.email) && !Utils.isEmpty(_this.state.phoneNumber);
        };

        _this.closeUserProfileModal = function () {
            var currentUser = _parse2.default.User.current();
            var router = _this.props.history;
            var locId = _this.props.locId;

            if (!currentUser.get("phoneNumber")) {
                Utils.logOutAll(router, locId, false);
            }

            $('#' + _this.props.parentModalId).modal('hide');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            $('body').css('padding-right', '');
        };

        _this.submit = function (e) {
            e.preventDefault();
            if (!_this.validateUserDetails()) {
                _this.setState({
                    error: 'Fields can not be empty!'
                });
                return;
            }

            var phoneNo = Utils.removeNonNumber(_this.state.phoneNumber);

            var sname = _this.state.name.replaceAll(/\s+/g, ' ').trim();

            if (Utils.isEmpty(sname)) {
                _this.setState({
                    error: 'User name is empty.'
                });
                return;
            }

            if (phoneNo.length !== 10) {
                _this.setState({
                    error: "Phone number must be of 10 Digits."
                });
                return;
            }

            var currentUser = _parse2.default.User.current();
            currentUser.set("username", _this.state.email);
            currentUser.set("email", _this.state.email);
            currentUser.set("name", sname);
            // currentUser.set("name", this.state.name.replace(/[^a-zA-Z]/gi,' ').replaceAll(/\s+/g, ' ').trim());
            currentUser.set("phoneNumber", phoneNo);
            currentUser.save().then(function () {
                // console.log("User updated successfully.");
                _this.setState({
                    success: true,
                    infoMessage: null,
                    error: null
                });

                // close the user profile modal
                _this.closeUserProfileModal();
            }, function (error) {

                var router = _this.props.history;
                var locId = _this.props.locId;
                // check the error and alert the invalid session token
                Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
                _this.closeUserProfileModal();
                // console.log("Error:"+error);
                // this.setState({
                //     error   : error.message,
                //     success : false
                // });
            });
        };

        _this.state = {
            name: '',
            email: '',
            phoneNumber: '',
            infoMessage: null,
            readOnly: ''
        };
        return _this;
    }

    _createClass(UserProfile, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.populateUserDetails();
        }

        // changePhoneNumber = (e) => {
        //     this.setState({
        //         phoneNumber : e.target.value
        //     });
        // }

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12 col-md-12' },
                    !Utils.isEmpty(this.state.infoMessage) ? _react2.default.createElement(
                        'div',
                        { className: 'alert alert-info', role: 'alert' },
                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            'Info:'
                        ),
                        this.state.infoMessage
                    ) : null,
                    !Utils.isEmpty(this.state.error) ? _react2.default.createElement(
                        'div',
                        { className: 'alert alert-danger', role: 'alert' },
                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            'Error:'
                        ),
                        this.state.error
                    ) : null,
                    this.state.success ? _react2.default.createElement(
                        'div',
                        { className: 'alert alert-success', role: 'success' },
                        _react2.default.createElement('span', { className: 'glyphicon glyphicon-ok', 'aria-hidden': 'true' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'sr-only' },
                            'Success :'
                        ),
                        'Profile has been updated successfully.'
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        {
                            id: 'profileform',
                            className: 'form-horizontal',
                            onKeyDown: this.keyDown,
                            onSubmit: this.submit,
                            role: 'form'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'cc-exp', className: 'control-label' },
                                    'Name'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-group' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'input-group-addon' },
                                        _react2.default.createElement(
                                            'i',
                                            {
                                                className: 'material-icons',
                                                style: { fontSize: 20 }
                                            },
                                            'account_circle'
                                        )
                                    ),
                                    _react2.default.createElement('input', {
                                        type: 'text',
                                        className: 'form-control',
                                        onChange: this.changeName,
                                        value: this.state.name,
                                        name: 'name',
                                        placeholder: 'Name',
                                        title: 'Numbers & Special Characters not Allowed like (@ * . # ! $ ^ &)',
                                        pattern: '[ a-zA-Z][ a-zA-Z ]+[ a-zA-Z]$'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'cc-exp', className: 'control-label' },
                                    'Email'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-group' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'input-group-addon' },
                                        _react2.default.createElement(
                                            'i',
                                            {
                                                className: 'material-icons',
                                                style: { fontSize: 20 } },
                                            'email'
                                        )
                                    ),
                                    _react2.default.createElement('input', {
                                        type: 'email',
                                        className: 'form-control',
                                        onChange: this.changeEmail,
                                        value: this.state.email,
                                        name: 'username',
                                        placeholder: 'Email Address',
                                        title: 'Email Address',
                                        required: true,
                                        readOnly: this.state.readOnly
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'cc-exp', className: 'control-label' },
                                    'Phone Number'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-group' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'input-group-addon' },
                                        _react2.default.createElement(
                                            'i',
                                            {
                                                className: 'material-icons',
                                                style: { fontSize: 20 }
                                            },
                                            'phone'
                                        )
                                    ),
                                    _react2.default.createElement('input', {
                                        id: 'Phone',
                                        type: 'tel',
                                        ref: 'phone',
                                        placeholder: 'Phone Number',
                                        title: 'Phone Number',
                                        name: 'phoneNumber',
                                        className: 'form-control',
                                        onChange: function onChange(e) {
                                            return _this2.handleInput(e);
                                        },
                                        value: this.state.phoneNumber,
                                        required: true
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                _react2.default.createElement(
                                    _SimpleButton2.default,
                                    {
                                        classNames: 'themebtn btn-block btn-styl',
                                        id: 'btn-signup',
                                        inputType: 'submit'
                                    },
                                    'Update'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return UserProfile;
}(_react2.default.Component);

exports.default = UserProfile;


//////////////////
// WEBPACK FOOTER
// ./src/components/account/UserProfile.jsx
// module id = 540
// module chunks = 0